import { checkImportExact, clearExistingScheduledImports} from './import';
import { getCookie, getCurrentUser, enableUpdateImports, updateUserLastAction } from './utils';

// Handles exactonline import execution on the server
export async function handleImport(row, updateStatus){
  // await checkImportExact(data[id].entiteit, data[id].year, data[id].budget_scenario, office);
  try {
    handleStatus(updateStatus, true);

    const response = await fetch('microsoftdynamics/executeImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify({
        entiteit: row.entiteit,
        year: row.year,
        budget_scenario: row.budget_scenario,
        office: row.office,
        user_id: await getCurrentUser(),
      }),
    });
    if (response.ok) {
      await enableUpdateImports();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    handleStatus({"text": "Error!", "progress": 1, "status": 0});
  }
}
export async function getMicrosoftDynamicsCompany(){
  var config = await getMicrosoftDynamicsConfig(await getCurrentUser());
  const response = await fetch('microsoftdynamics/getCompany', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config),
  });
  if (response.ok) {
    const responseData = await response.json();

    if(responseData){
      return responseData;
    }
  }
}

export async function test(currentUser){
  // var response = await fetch('microsoftdynamics/test?user_id='+currentUser);
  // if (response.ok) {
  //   var responseData = response.json();
  //   console.log(responseData);
  // }
}
export async function getAdministrations(currentUser){
  var response = await fetch('microsoftdynamics/fetchCompanies?user_id='+currentUser);
  if (response.ok) {
    var responseData = await response.json(); 
    
    if(responseData && responseData.value){
      var administration = [];
      for(var i = 0; i < responseData.value.length; i++){
        administration.push({"Code": responseData.value[i].id, "Description": responseData.value[i].displayName});
      }
      return administration;
    }
    else{
      return false;
    }
  }
  else{
    return false;
  }
}

async function findByDivision(office){
  var response = await fetch('/import_MicrosoftDynamics/getListArray?division='+office);
  if(response.ok){
    var responseData = response.json();
    return responseData;
  }
}

// Update import exact factview and exactonline tokens
export async function updateImportMicrosoftDynamicsByOffice(office){
  var imp = await findByDivision(office);
  if(imp){
    for(var i = 0; i < imp.length; i++){
      await fetch('/import_MicrosoftDynamics/updateImportMicrosoftDynamicsTokens', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: imp[i].id,
          factview_access: getCookie('factview_access'),
          factview_refresh: getCookie('factview_refresh'),
          exact_access: getCookie('exact_access'),
          exact_refresh: getCookie('exact_refresh'),
        }),
      });  
   }
  }
  
}
export async function getMicrosoftDynamicsConfig(currentUser){
  try{
    const response = await fetch('https://api2.factview.nl/user/getMicrosoftDynamics?currentUser='+currentUser, {
      method: 'GET',
      headers: {
        'authorization': 'Bearer '+ getCookie("factview_access"),
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      }
    });

    if (response.ok) {
      const responseData = await response.json();

      if(responseData){
        
        return responseData;
      }
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function getImportMicrosoftDynamics(mvLink){
  try{
    const response = await fetch('microsoftdynamics/getImportMicrosoftDynamics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fourps_link: mvLink
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function createImport(importConfig){
  try{
    updateUserLastAction();
    const response = await fetch('microsoftdynamics/createImportMicrosoftDynamics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(importConfig),
    })
    if (response.ok) {
      const responseData = await response.json();
      
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}



//Submits import MicrosoftDynamics updates/changes
export async function updateImportMicrosoftDynamics(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_MicrosoftDynamics/updateImportMicrosoftDynamics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImportMicrosoftDynamics(id){
  try { 
    // var importData = data.filter(item => item.id == id)[0];
    const importResponse = await fetch('/import_MicrosoftDynamics/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();

      await clearExistingScheduledImports({"import_type": "MicrosoftDynamics", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]});
      
      const response = await fetch('/import_MicrosoftDynamics/deleteImportMicrosoftDynamics?id='+id);
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
          
        }
      }
    
    }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}

// Handles fetching status updates from the server
async function handleStatus(updateStatus, init){
  try{
    if(init){
      await fetch('microsoftdynamics/resetStatus');
      setTimeout(function(){
        handleStatus(updateStatus, false, 0);
      },500);
    }else{
      const response = await fetch('microsoftdynamics/fetchUpdates');
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
          updateStatus(responseData);

          if(responseData.length > 0 && responseData[responseData.length-1]["status"] == 1){
            setTimeout(function(){
              handleStatus(updateStatus, false);
            }, 750);
          }
        } 
      }
    }
  } catch(error) {
    setTimeout(function(){
      handleStatus(updateStatus, false);
    },500);
  }
  
}


